import axios from 'axios'
import { EvalComment, getEvaluationCommentUrl } from '../SingleEvaluationForm/evaluationForm.api'

export const getComments = (ccrId: number, evalId: number) => axios.get<EvalComment[]>(getEvaluationCommentUrl(ccrId, evalId))
  .then(res => res.data)
